export const Panel = ({ step, title, children, testid }) => (
  <div data-testid={testid} className="glass rounded-2xl p-6 rise">
    <div className="font-mono-ui text-[11px] uppercase tracking-[0.2em] text-emerald-400/80 mb-2">{step}</div>
    <h2 className="font-display font-bold text-lg mb-5">{title}</h2>
    {children}
  </div>
);
